import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthSessionService } from '../../../core/auth-session.service';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './login-page.component.html'
})
export class LoginPageComponent {
  private readonly fb = inject(FormBuilder);
  private readonly auth = inject(AuthSessionService);
  private readonly router = inject(Router);

  submitting = false;
  errorMessage = '';

  readonly form = this.fb.nonNullable.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]]
  });

  async submit(): Promise<void> {
    if (this.form.invalid || this.submitting) {
      return;
    }

    this.submitting = true;
    this.errorMessage = '';
    try {
      const { email, password } = this.form.getRawValue();
      await this.auth.login(email, password);

      if (this.auth.isAdmin()) {
        await this.router.navigate(['/admin']);
        return;
      }

      if (this.auth.isAccount()) {
        await this.auth.logout();
        this.errorMessage = 'This login is for administrators. Use Partner Login instead.';
        return;
      }

      await this.auth.logout();
      this.errorMessage = 'This login is for administrators only.';
    } catch {
      this.errorMessage = 'Login failed. Check your email and password.';
    } finally {
      this.submitting = false;
    }
  }
}